import APIClient from '@/shared/http/clients/api'

const APIPci = process.env.APIBaseURLPci
const resourceName = 'PDRRelatorioMedia'

const GetAll = (empresaID, limit, index, data = {}, config = {}) => APIClient.get(`${APIPci}/${resourceName}/${empresaID}?limit=${limit}&index=${index}`, data, config)
const Create = (empresaID, data = {}, config = {}) => APIClient.post(`${APIPci}/${resourceName}/${empresaID}`, data, config)
const Delete = (id, config = {}) => APIClient.delete(`${APIPci}/${resourceName}/${id}`, config)
const PrintReport = (empresaID, data = {}, config = {}) => APIClient.post(`${APIPci}/${resourceName}/relatorio/${empresaID}`, data, config)

export default {
  GetAll,
  Create,
  Delete,
  PrintReport
}



// WEBPACK FOOTER //
// ./src/shared/http/repositories/pci/pdrrelatoriomedia.js